import { render, staticRenderFns } from "./service-inquiry-state-edit.vue?vue&type=template&id=09e2f10a"
import script from "./service-inquiry-state-edit.vue?vue&type=script&lang=js"
export * from "./service-inquiry-state-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports